import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { unsubscribe } from '@fcom/core/utils';
import { LoaderType, ToasterService } from '@fcom/common';
import { LoyaltyRoutesPath } from '@fcom/loyalty-core';
import { finShare } from '@fcom/rx';
import { NotificationTheme } from '@fcom/ui-components';

import { CampaignService } from '../../services/campaign.service';

@Component({
  templateUrl: 'campaign-enroll.component.html',
  styleUrls: ['../../../loyalty-core/assets/styles/common.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignEnrollComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  public readonly LoaderType = LoaderType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
    private toasterService: ToasterService,
    private campaignService: CampaignService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.activatedRoute.queryParams
        .pipe(
          switchMap((params) => {
            if (params.campaignId && params.mni) {
              return this.campaignService.enrollToCampaign(params.campaignId, params.mni);
            }
            throw new Error('Invalid params');
          }),
          finShare()
        )
        .subscribe({
          next: () => this.navigateToFrontpageWithMessage(),
          error: () => this.navigateToError(),
        })
    );
  }

  navigateToFrontpageWithMessage(): void {
    this.toasterService.addMessageToQueue({
      id: 'enroll-successful',
      contentKey: 'LOYALTY.enroll.success',
      keepMessageAfterNavigation: true,
      theme: NotificationTheme.SUCCESS,
    });
    this.router.navigate([this.languageService.langValue], {
      skipLocationChange: false,
    });
  }

  navigateToError(): void {
    this.router.navigate([this.languageService.langValue, LoyaltyRoutesPath.PLUS, LoyaltyRoutesPath.ERROR], {
      skipLocationChange: false,
    });
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
